<template>
  <div class="pl-page">
    <pro-list-frame
      v-if="isDesktopListLayout"
      ref="plTable"
      :title="($t($route.name))"
      icon="mdi-book-open-page-variant-outline"
      :total="totalItems"
      :rows="items.length"
      :search.sync="search"
      :columns="toggleableHeaders"
      :hidden="hiddenColumns"
      :selected-count="(selected || []).length"
      :loading="loading"
      :cell-sel="cellSel"
      :fixed="!mobileShow"
      :create-label="$t('checkpage')"
      @refresh="getItems"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo('checkpage')"
      @toggle-column="toggleColumn"
      @show-all-columns="hiddenColumns = []"
      @cell-down="onCellDown"
      @cell-over="onCellOver"
      @clear-cells="clearCellSel"
      @clear-selection="selected = []"
    >
      <template #bulk>
      <button
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
      </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="checkpageListColumnPlugins"
        v-column-drag="checkpageListColumnPlugins"
        v-column-pin="checkpageListColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        v-model="selected"
        :headers="tableHeaders"
        :items="items"
        :page.sync="page"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="false"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :footer-props="plFooterProps"
      >
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  class="pl-action-cell__btn"
                  v-bind="attrs"
                  icon
                  x-small
                  v-on="on"
                >
                  <v-icon small> mdi-dots-vertical </v-icon>
                </v-btn>
              </template>

              <v-list dense>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink">
                    mdi-trash-can-outline
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
              </v-list>
            </v-menu>
            <span class="pl-action-cell__row">{{
              parseInt(items.indexOf(item)) + parseInt(from)
            }}</span>
          </div>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div
                v-if="item.user"
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                {{ item.user.firstname }}  {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            v-if="item.status === 'active'"
            small
            color="blue"
            outlined
          >
            {{ $t('active') }}
          </v-chip>
          <v-chip
            v-if="item.lead === 'active'"
            small
            color="orange"
            class="mx-1"
            outlined
          >
            {{ $t('lead') }}
          </v-chip>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.remain="{ item }">
          {{ (item.remain ? $numberFormat(item.remain.remain) : 0) }}
          {{(item.remain && $store.state.currency.id !== item.remain.currency.id ? '(' + item.remain.currency_remain + '  ' + item.remain.currency.symbol + ')': '')}}
        </template>
        <template v-slot:item.currency="{ item }">
          {{item.currency.name}}
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1"
          >
            <span class="px-2 white--text">
              {{ item.last_status.status.name }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <!-- Desktop fixed viewport: page totals sit above pagination, outside body scroll -->
          <div
            v-if="!isMobile && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__label">{{ $t('sumInPage') }}</span>
            <span
              class="app-list-page-totals__item app-list-page-totals__item--final"
            >
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.sum) }}
              </span>
            </span>
          </div>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
        <template
          v-slot:body.append
        >
          <tr
            v-if="isMobile || mobileShow"
            :class="{'v-data-table__mobile-table-row':isMobile}"
          >
            <td
              :colspan="`${isMobile?6:7}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              <strong>{{ $t('sum') }}</strong>
            </td>
            <td
              :colspan="`${isMobile?6:1}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            >
              {{ (isMobile ? $t('sum') +':': '') }}  {{ $numberFormat(totals.sum) }}
            </td>
            <td
              :colspan="`${isMobile?6:5}`"
              :class="{'v-data-table__mobile-row':isMobile}"
            />
          </tr>
        </template>
      </v-data-table>
    </pro-list-frame>
    <pro-list-mobile
      v-else
      :title="($t($route.name))"
      :items="items"
      :total="totalItems"
      :loading="loading"
      :page="plPage"
      :page-count="pageCount || 1"
      :search.sync="search"
      :filterable="true"
      :printable="true"
      :card="plAutoCard"
      :actions="plAutoActions"
      :create-label="$t('checkpage')"
      @load-more="plLoadPage"
      @refresh="plLoadPage(1)"
      @print="printStudio = true"
      @filter="filter = true"
      @create="goTo('checkpage')"
    />
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t($route.name))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />

      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="printDialog"
      width="70%"
    >
      <v-card>
        <v-col
          class="d-flex pb-0"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="printDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('print') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <print
            :header-prop="showHeaders"
            :items-prop="items"
            :title="$t($route.name)"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
            <v-dialog
      v-model="filter"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="720"
      scrollable
      content-class="acf-wrap"
    >
      <div class="acf acf--compact" :style="proListRootStyle" dir="rtl">
        <header class="acf-head">
          <span class="acf-head__icon">
            <v-icon size="18">mdi-filter-variant</v-icon>
          </span>
          <div class="acf-head__titles">
            <div class="acf-head__title">{{ $t("checkpageFilterTitle") }}</div>
            <div class="acf-head__sub">
              <template v-if="activeFilterChips.length">
                <span class="acf-badge">{{ faNum(activeFilterChips.length) }}</span>
                {{ $t("accFilterActive") }}
              </template>
              <template v-else>{{ $t("accFilterNone") }}</template>
            </div>
          </div>
          <button type="button" class="acf-x" :title="$t('close')" @click="filter = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="acf-body">
          <section class="acf-sec">
            <div class="acf-sec__head">
              <v-icon size="17">mdi-shape-outline</v-icon>
              {{ $t("bankFilterStatus") }}
            </div>
            <div class="acf-grid acf-grid--3">
              <v-select
                v-model="productStatus"
                :label="$t('status')"
                :items="productStatusItems"
                dense
                outlined
                multiple
                hide-details
                item-value="value"
                item-text="text"
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0" class="acf-sel">{{ item.text }}</span>
                  <span v-if="index === 1" class="acf-sel acf-sel--more">
                    +{{ faNum((productStatus || []).length - 1) }}
                  </span>
                </template>
              </v-select>
              <status v-model="sellStatus" :hideconfig="true" />
              <tag v-model="tag" />
            </div>
          </section>
        </div>

        <footer class="acf-foot">
          <button type="button" class="acf-btn acf-btn--primary" @click="applyCheckpageFilter">
            <v-icon size="16">mdi-filter-check-outline</v-icon>
            {{ $t("accFilterApply") }}
          </button>
          <button
            type="button"
            class="acf-btn acf-btn--ghost"
            :disabled="!activeFilterChips.length"
            @click="resetFilters"
          >
            <v-icon size="16">mdi-filter-remove-outline</v-icon>
            {{ $t("accDocListClearFilters") }}
          </button>
          <span class="acf-spacer" />
          <button type="button" class="acf-btn" @click="filter = false">
            {{ $t("cancel") }}
          </button>
        </footer>
      </div>
    </v-dialog>
<v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            color="grey darken-2"
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            task-type="account"
            :ref-id="refId"
            :task-id="taskId"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="deletDialog"
      width="400"
    >
      <v-card>
        <v-col>
          <v-btn
            icon
            class="close-hover"
            @click="deletDialog = false"
          >
            <v-icon
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
        </v-col>
        <v-col>
          <v-img
            class="mx-auto"
            width="200"
            src="@/assets/stop.svg"
          />
        </v-col>
        <v-col
          class="mt-3 pr-7"
        >
          <p class="mx-auto font-weight-medium">
            {{ $t('are-you-sure-delete-this-case') }}
          </p>
        </v-col>
        <v-card-actions>
          <v-row class="ma-0">
            <v-col cols="6">
              <v-btn
                v-if="selected.length > 0"
                color="primary"
                @click="removegroup"
              >
                {{ $t('remove') }}
              </v-btn>
              <v-btn
                v-if="selected.length == 0"
                color="primary"
                @click="remove"
              >
                {{ $t('remove') }}
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                color="grey"
                outlined
                class="float-left"
                @click="deletDialog = false"
              >
                {{ $t('cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor"
    />
  </div>
</template>

<script>
  import Task from '../task/task'
  import Print from '../../components/general/Print/Index'
  import General from '../../../../Mixins/general'
  import {
    applyColumnSettings,
    loadColumnSettings,
  } from '@/plugins/columnSettings/columnSettings'
  import { reorderPinnedHeaders } from '@/plugins/columnPin/columnPin'
  import ProList from "@/Mixins/proList";
  import ProListFrame from "@/components/proList/ProListFrame.vue";
  import ProListMobile from "@/components/proList/ProListMobile.vue";
  import PrintStudio from "@/modules/print/PrintStudio.vue";
  export default {
    name: 'checkPageList',
    components: {
      ProListFrame,
      ProListMobile,
      PrintStudio,
      Snakbar: () => import('../../components/general/snakbar/snakbar'),
      Tag: () => import('../../components/general/Tag/tag'),
      Status: () => import('../../components/general/Status/status'),
      Print,
      Task,
    },
    mixins: [General, ProList],
    props: ['input', 'refId', 'mobileShow'],
    data: () => ({
      selected: [],
      pageCount: 1,
      page: 1,
      selectedHeaders: [],
      printDialog: false,
      deletDialog: false,
      filter: false,
      productStatus: null,
      productStatusItems: null,
      model: null,
      from: 1,
      taskDialog: null,
      tag: null,
      temp: null,
      deleteItem: null,
      sellStatus: null,
      items: [],
      sortBy: [],
      dialog: null,
      timer: 0,
      totalItems: 0,
      snakbar: false,
      typeForm: null,
      taskId: null,
      snakbarText: null,
      loading: true,
      options: {
        itemsPerPage: 5,
      },
      headers: null,
      type: null,
      listViewportObserver: null,
      listViewportRaf: null,
      search: null,
    }),
    computed: {

      activeFilterChips () {
        var app = this
        var has = function (v) {
          if (Array.isArray(v)) return v.length > 0
          return v !== null && v !== undefined && v !== '' && v !== '0' && v !== 0
        }
        var show = function (v) {
          if (Array.isArray(v)) return v.length > 1 ? String(v.length) : show(v[0])
          if (v && typeof v === 'object') return v.name || v.text || v.label || ''
          return typeof v === 'number' || typeof v === 'string' ? String(v) : ''
        }
        var pick = function (items, v, key) {
          var arr = Array.isArray(v) ? v : [v]
          return arr
            .map(function (x) {
              var f = (items || []).find(function (i) { return i.value === x })
              return f ? f[key || 'text'] : ''
            })
            .filter(Boolean)
            .join('، ')
        }
        var defs = [
          ['productStatus', app.$t('status'), pick(app.productStatusItems, app.productStatus)],
          ['sellStatus', app.$t('status')],
          ['tag', app.$t('tag')],
        ]
        return defs
          .filter(function (d) { return has(app[d[0]]) })
          .map(function (d) {
            return { key: d[0], label: d[1], value: d.length > 2 ? d[2] : show(app[d[0]]) }
          })
      },

      proListKey () {
        return this.checkpageListColumnPersistKey
      },
      proListLocked () {
        return this.checkpageListLockedColumns
      },
      showSelect () {
        if(!this.isMobile) {
          return true
        } else {
          return false
        }
      },
      showHeaders () {
        var app = this
        return this.headers.filter(function (s) {
          return app.selectedHeaders.includes(s)
        })
      },
      isMobile () {
        return this.$vuetify.breakpoint.name === 'xs'
      },
      isDesktopListViewport () {
        return !this.isMobile && !this.mobileShow
      },
      checkpageListColumnPersistKey () {
        return 'treasury-checkpage-list-columns-' + (this.$route.name || 'checkpageList')
      },
      checkpageListLockedColumns () {
        // Fixed sticky block: select + actions + id (no unpin/drag)
        var locked = ['actions', 'id']
        return this.showSelect ? ['__select'].concat(locked) : locked
      },
      checkpageListColumnPlugins () {
        // show-select inserts a leading checkbox <th>; pad visibleHeaders so
        // pin/resize/drag index mapping stays aligned with thead cells.
        var selectHeader = {
          value: '__select',
          text: '',
          width: 32,
          sortable: false,
          pinned: false,
          originalIndex: -1,
        }
        var visible = this.showSelect
          ? [selectHeader].concat(this.tableHeaders || [])
        : this.tableHeaders || []
        return {
          headers: this.headers,
          visibleHeaders: visible,
          locked: this.checkpageListLockedColumns,
          anchor: 'id',
          minWidth: 60,
          persistKey: this.checkpageListColumnPersistKey,
        }
      },
      totals: function () {
        const totals = this.items.reduce((acc, d) => {
          acc.sum += (d.count ? parseFloat(d.count) : 0)
          acc.discount += parseFloat(0)
          acc.tax += parseFloat(0)
          return acc
        }, {
          sum: 0,
          discount: 0,
          tax: 0,
        })
        return totals
      },
    },
    watch: {
      refId (val, oldVal) {
        // this.items = []
        this.getItems()
      },
      model () {
        this.$emit('input', this.model)
      },
      selected () {
        this.$emit('input', this.selected.text)
        if (this.selected.length > 0) {
          this.model = this.selected[0].text
          this.temp = this.selected[0].text
        }
        this.dialog = false
      },
      search () {
        var app = this
        app.loading = true
        app.page = 1
        clearTimeout(this.timer)
        this.timer = setTimeout(function () {
          app.getItems()
        }, 1000)
      },
      options: {
        handler () {
          var app = this
          app.sortBy = []
          app.options.sortBy.map(function (value, key) {
            const index = app.headers.findIndex(h => h.value === value)
            app.sortBy.push(app.headers[index].table)
          })
          this.getItems()
        },
        deep: true,
      },
      sortBy () {
        const index = this.headers.findIndex(h => h.value === this.sortBy)
        if (index > -1) {
          this.sortBy = this.headers[index].table
        }
      },
      loading (val) {
        if (!val && this.isDesktopListViewport) {
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        }
      },
      isDesktopListViewport (val) {
        if (val) {
          this.$nextTick(() => {
            this.updateDesktopTableHeight()
            this.bindListViewportObserver()
          })
        } else {
          this.unbindListViewportObserver()
          this.tableHeight = window.innerHeight - 245
        }
      },
    },
    activated () {
      this.type = 'checkpage'
      this.getItems()
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver()
          this.scheduleDesktopTableHeightUpdate()
        })
      }
    },
    beforeMount () {
      this.headers = [
        {
          text: this.$t('#'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 42,
          class: 'pl-action-col',
          cellClass: 'pl-action-col',
        },
        {
          text: this.$t('id'),
          sortable: true,
          value: 'check_series',
          table: 'checks.check_series',
        },
        {
          text: this.$t('bank'),
          sortable: true,
          value: 'bank.name',
        },
        {
          text: this.$t('number') + ' ' + this.$t('account'),
          sortable: false,
          value: 'bank.number',
        },
        {
          text: this.$t('firstNumberPage'),
          sortable: false,
          value: 'number',
        },
        {
          text: this.$t('lastNumberPage'),
          sortable: false,
          value: 'lastnumber',
        },
        {
          text: this.$t('count'),
          sortable: false,
          value: 'count',
        },
        {
          text: this.$t('registerar'),
          sortable: false,
          value: 'user.name',
        },
      ]
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      }
    },
    mounted () {
      if (this.input) {
        this.model = this.input
      }
      this.selectedHeaders = this.headers
      reorderPinnedHeaders(this.headers, {
        locked: this.checkpageListLockedColumns,
        anchor: 'id',
      })
      this.loadCheckpageListColumnSettings()
      this.getItems()
      if (this.isDesktopListViewport) {
        this.$nextTick(() => {
          this.bindListViewportObserver()
          this.updateDesktopTableHeight()
          this.$nextTick(() => {
            this.bindListViewportObserver()
            this.scheduleDesktopTableHeightUpdate()
          })
        })
      }
    },
    deactivated () {
      this.unbindListViewportObserver()
    },
    beforeDestroy () {
      this.unbindListViewportObserver()
      if (this.listViewportRaf) {
        cancelAnimationFrame(this.listViewportRaf)
        this.listViewportRaf = null
      }
    },
    methods: {

      applyCheckpageFilter () {
        this.filter = false
        this.getItems()
      },
      resetFilters () {
        this.productStatus = null
        this.sellStatus = null
        this.tag = null
      },

      resolveRefEl (ref) {
        if (!ref) return null
        return ref.$el || ref
      },
      onResize () {
        if (this.isDesktopListViewport) {
          this.updateDesktopTableHeight()
          return
        }
        this.tableHeight = window.innerHeight - 245
      },
      scheduleDesktopTableHeightUpdate () {
        if (this.listViewportRaf) cancelAnimationFrame(this.listViewportRaf)
        this.listViewportRaf = requestAnimationFrame(() => {
          this.listViewportRaf = null
          this.updateDesktopTableHeight()
        })
      },
      updateDesktopTableHeight () {
        if (!this.isDesktopListViewport) {
          this.tableHeight = window.innerHeight - 245
          return
        }
        const rootEl = this.resolveRefEl(this.$refs.listRoot)
        const toolbarEl = this.resolveRefEl(this.$refs.listToolbar)
        const summaryEl = this.resolveRefEl(this.$refs.listSummary)
        const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
        const tableEl = this.resolveRefEl(this.$refs.listTable)
        if (!rootEl || !tableColEl) {
          this.tableHeight = window.innerHeight - 245
          return
        }
        const rootStyle = window.getComputedStyle(rootEl)
        const rootPadding =
          (parseFloat(rootStyle.paddingTop) || 0) +
          (parseFloat(rootStyle.paddingBottom) || 0)
        const toolbarHeight = toolbarEl ? toolbarEl.offsetHeight : 0
        let summaryHeight = 0
        if (summaryEl) {
          const summaryVisible =
            summaryEl.offsetParent !== null ||
            summaryEl.getClientRects().length > 0
          if (summaryVisible) {
            const summaryStyle = window.getComputedStyle(summaryEl)
            summaryHeight =
              summaryEl.offsetHeight +
              (parseFloat(summaryStyle.marginTop) || 0) +
              (parseFloat(summaryStyle.marginBottom) || 0)
          }
        }
        const colStyle = window.getComputedStyle(tableColEl)
        const colPadding =
          (parseFloat(colStyle.paddingTop) || 0) +
          (parseFloat(colStyle.paddingBottom) || 0)
        const footerEl = tableEl
          ? tableEl.querySelector('.v-data-footer')
          : null
        const footerHeight = footerEl ? footerEl.offsetHeight : 0
        const tableStyle = tableEl ? window.getComputedStyle(tableEl) : null
        const tableMargins = tableStyle
          ? (parseFloat(tableStyle.marginTop) || 0) +
            (parseFloat(tableStyle.marginBottom) || 0)
          : 0
        const available =
          rootEl.clientHeight -
          rootPadding -
          toolbarHeight -
          summaryHeight -
          colPadding -
          footerHeight -
          tableMargins -
          3
        this.tableHeight = Math.max(180, Math.floor(available))
      },
      bindListViewportObserver () {
        if (typeof ResizeObserver === 'undefined') return
        this.unbindListViewportObserver()
        const rootEl = this.resolveRefEl(this.$refs.listRoot)
        const summaryEl = this.resolveRefEl(this.$refs.listSummary)
        const tableColEl = this.resolveRefEl(this.$refs.listTableCol)
        const tableEl = this.resolveRefEl(this.$refs.listTable)
        const footerEl = tableEl ? tableEl.querySelector('.v-data-footer') : null
        if (!rootEl && !summaryEl && !tableColEl) return
        this.listViewportObserver = new ResizeObserver(() => {
          this.scheduleDesktopTableHeightUpdate()
        })
        if (rootEl) this.listViewportObserver.observe(rootEl)
        if (summaryEl) this.listViewportObserver.observe(summaryEl)
        if (tableColEl) this.listViewportObserver.observe(tableColEl)
        if (footerEl) this.listViewportObserver.observe(footerEl)
      },
      unbindListViewportObserver () {
        if (this.listViewportObserver) {
          this.listViewportObserver.disconnect()
          this.listViewportObserver = null
        }
      },
      loadCheckpageListColumnSettings () {
        var app = this
        if (!app.headers || !app.headers.length) return
        loadColumnSettings(app, app.checkpageListColumnPersistKey).then(function (snapshot) {
          if (!snapshot || !snapshot.length) return
          applyColumnSettings(app.headers, snapshot, {
            locked: app.checkpageListLockedColumns,
            anchor: 'id',
          })
          app.$forceUpdate()
        })
      },
      openDeleteDialog (item) {
        this.deleteItem = item
        this.deletDialog = true
      },
      openTaskDialog (item) {
        this.refId = item.rel_id
        this.taskId = item.id
        this.taskDialog = true
      },
      isEnabled (slot) {
        return this.enabled === slot
      },
      edit (item) {
        return false
        // this.$router.push({ name: item.type + 'Edit', params: { id: item.id } })
      },
      getItems () {
        var app = this
        app.loading = true
        app.$axios.get(this.$endpoint + 'checkpage', {
          params: {
            search: app.search,
            page: app.options.page,
            refId: app.refId,
            type: app.type,
            sortBy: app.sortBy,
            status: app.productStatus,
            options: app.options,
            tag: app.tag,
            typeForm: app.typeForm,
          },
        })
          .then(res => {
            res = res.data
            app.items = res.data
            app.totalItems = res.total
            app.pageCount = res.last_page
            app.from = res.from
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      remove () {
        var app = this
        if (!app.deleteItem) return false
        app.loading = true
        app.$axios.delete(this.$endpoint + 'checkpage/' + this.deleteItem.id)
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      removegroup () {
        var app = this
        app.loading = true
        app.$axios.delete(this.$endpoint + 'checkpage/0', {
          params: { deleteItems: app.selected },
        })
          .then(res => {
            res = res.data
            app.deletDialog = false
            app.deleteItem = null
            app.selected = []
            app.getItems()
          })
          .catch(err => {
            this.deletDialog = false
            this.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
    },
  }
</script>

<style scoped lang="scss">
@import "~@/sass/design-system/list/pro-list";

::v-deep .v-data-table table thead tr th,
::v-deep .v-data-table table tbody tr td {
  white-space: nowrap;
}
::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
</style>
